import { hasAccessToBrandId, isValidDashboardUser } from './userService';
import firebaseBrandsService from '../firebase/brands';
import utils from '../utils';
import { CommonLogger } from '../logger';

export const getPortfolioBrands = async (user, allBrandsMap, token) => {
  const brands = getAccessibleBrands(user, allBrandsMap);

  if (brands === undefined) {
    return [];
  }

  const portfolioMap = await getPortfolioMap(token);

  const portfolio = brands.map(b => getPortfolioBrand(b, portfolioMap));

  checkAndWarnDuplicates(portfolio);

  return portfolio;
};

export const getSelectedPortfolioBrands = (portfolioBrands, selectedBrandIds) => {
  return portfolioBrands.map(b => {
    return {
      ...b,
      checked: selectedBrandIds.includes(b.value),
    };
  });
};

export const getCurrentBrand = (user, storedBrandId, defaultBrand, portfolioBrands) => {
  const currentBrandId = getCurrentBrandId(user, storedBrandId, defaultBrand, portfolioBrands);
  const currentBrand = currentBrandId && portfolioBrands.find(b => b.brandId === currentBrandId);

  return currentBrand || portfolioBrands[0];
};

const checkAndWarnDuplicates = (portfolio) => {
  portfolio.reduce((brands, { brandName }) => {
    if (brands[brandName]) {
      CommonLogger.warn('Duplicated brand name in portfolio', { brandName });
    }
    brands[brandName] = true;

    return brands;
  }, {});
};

const getAccessibleBrands = (user, allBrandsMap) => {
  if (!isValidDashboardUser(user) || !allBrandsMap) {
    return undefined;
  }

  const accessibleBrands = Object.values(allBrandsMap).reduce((brands, b) => {
    return b.isActive && hasAccessToBrandId(user, b.brandId)
      ? brands.concat(b)
      : brands;
  }, []);

  return utils.sortArrayByKey(accessibleBrands, 'brandName');
};

const getPortfolioMap = async (token) => {
  try {
    const portfolios = await firebaseBrandsService.getAllActivePortfolios(token);

    return portfolios.reduce((map, { id, name }) => {
      map[id] = name;

      return map;
    }, {});
  } catch (err) {
    return null;
  }
};

const getPortfolioBrand = (brand, portfolioMap) => {
  const { brandId, brandName, portfolioId } = brand;

  const portfolioName = (portfolioMap && portfolioMap[portfolioId]) || '';

  return {
    ...brand,
    key: brandName,
    value: brandId,
    portfolioName: portfolioName,
  };
};

const getCurrentBrandId = (user, storedBrandId, defaultBrand, portfolioBrands) => {
  if (!isValidDashboardUser(user)) {
    return null;
  }

  if (brandExistsAndUserHasAccess(user, storedBrandId)) {
    return storedBrandId;
  }

  const defaultBrandId = defaultBrand && defaultBrand.brandId;

  if (brandExistsAndUserHasAccess(user, defaultBrandId)) {
    return defaultBrandId;
  }

  const firstBrandId = portfolioBrands && portfolioBrands[0] && portfolioBrands[0].brandId;

  if (brandExistsAndUserHasAccess(user, firstBrandId)) {
    return firstBrandId;
  }

  return null;
};

const brandExistsAndUserHasAccess = (user, brandId) => {
  return brandId && hasAccessToBrandId(user, brandId);
};
